import { Component } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { SupabaseService } from '../../../../shared/services/supabase.service';
import { Router } from '@angular/router';
import { TranslatePipe } from '../../../../pipes/translate.pipe';

@Component({
  selector: 'app-update-password',
  imports: [
    MatFormField,
    MatCard,
    MatCardTitle,
    MatCardContent,
    MatLabel,
    MatInput,
    MatButton,
    ReactiveFormsModule,
    TranslatePipe,
  ],
  templateUrl: './update-password.component.html',
  styleUrl: './update-password.component.scss',
})
export class UpdatePasswordComponent {
  constructor(
    private supabaseService: SupabaseService,
    private router: Router
  ) {}
  public form = new FormGroup({
    password: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(30),
    ]),
    confirmPassword: new FormControl('', [
      Validators.required,
      Validators.minLength(6),
      Validators.maxLength(30),
    ]),
  });
  public changePassword() {
    const value = this.form.value;
    if (value.confirmPassword !== value.password) {
      this.form.setErrors({ 'Passwords must match': true });
      return;
    }
    if (value.password && this.form.valid)
      this.supabaseService.supabase.auth
        .updateUser({
          password: value.password,
        })
        .then((res) => {
          // console.log(res);
          this.router.navigate(['/']);
        });
  }
}
